import React from "react";
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort';
import { findArray, filterArray } from 'helpers/utils';
import { getEvent } from "helpers/rsc";
import MirsTable from "components/general/table/Table";
import { TableColumnsExpanded } from 'components/sports/sho/components/TableColumns';

export const filterStages = (data) => {
    let stages = []
    if (data) {
        data?.map(s => {
            s?.extensions?.map(e => {
                if (e.ere_code === 'SERIES')
                    stages.push(e)
            })
        })
        return stages
    }
    return ''
}

const getResult = (data) => {
    let stages = []
    if (data) {
        data?.map(s => {
            s?.extensions?.map(e => {
                if (e.ere_code === 'SERIES_CUM')
                    stages.push(e)
            })
        })
        return stages[stages.length - 1]?.ere_value
    }
    return ''
}

export const TableExpanded = React.memo((props) => {
    const { breakPoint } = useViewport();
    let athletes = props.row.teamAthletes
    let isRifle = getEvent(props.rsc).slice(0, 2) === 'AR' || getEvent(props.rsc).slice(0, 2) === 'R3'
    let numSeries = props.numSeries

    console.log(props.rsc)

    if (breakPoint === 'sm' || breakPoint === 'xs') {
        return (
            <>
                <table className="table table-detail">
                    <thead>
                        <tr><th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            {isRifle && <th scope="col"></th>}
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {athletes.map((ath, index) => {
                            let tens = findArray(ath.extendedResults, { er_code: ['XS_NUM'] }).er_value
                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-5">&nbsp;</td>
                                        <td className="w-35"><Competitor {...ath.athlete} hidePicture={true} hideNoc={true} /></td>
                                        <td className="text-end">{getResult(filterArray(ath?.extResults, { er_code: ['STAGE'] }))}</td>
                                        {isRifle && <td className="text-end w-5">{tens}</td>}
                                        <td className="w-5"></td>
                                    </tr>
                                </>
                            )
                        })}
                    </tbody>
                </table >
            </>
        );
    }

    console.log(athletes)

    if (getEvent(props.rsc) === 'R3PMT-------------' && props.rsc.includes('FNL')) {
        return (
            <>
                < MirsTable
                    data={athletes}
                    columns={TableColumnsExpanded(numSeries)}
                    keyRow='participant-code'
                    sortable={false}
                    colsExtendedVisible={TableColumnsExpanded(numSeries).length > 10 ? '10,10' : '10,0'}
                    showNavExtendedData={TableColumnsExpanded(numSeries).length > 10 ? true : false}
                    id={`mirs-table-result-${props.rsc}`}
                /></>
        )
    }

    return (
        <>
            <table className="table table-detail">
                <thead>
                    <tr><th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        {Array.from(Array(numSeries), (e, i) => {
                            return <th key={i} scope="col"></th>
                        })}
                        {isRifle && <th scope="col"></th>}
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {athletes.map((ath, index) => {
                        let stages = filterStages(filterArray(ath.extResults, { er_code: ['STAGE'] }))
                        let tens = findArray(ath.extResults, { er_code: ['XS_NUM'] }).er_value
                        console.log(ath)
                        return (
                            <>
                                <tr key={index}>
                                    <td className="w-10">&nbsp;</td>
                                    <td className="w-15"><Competitor {...ath.athlete} hidePicture={true} hideNoc={true} /></td>
                                    {Array.from(Array(numSeries), (e, i) => {
                                        let value = findArray(stages, { ere_pos: [(i + 1).toString()] }).ere_value
                                        return <td key={i} className="text-end w-5">{value}</td>
                                    })}
                                    <td className="text-end w-5">{getResult(filterArray(ath?.extResults, { er_code: ['STAGE'] }))}</td>
                                    {isRifle && <td className="text-end w-5">{tens}</td>}
                                    <td className="w-10"></td>
                                </tr>
                            </>
                        )
                    })}
                </tbody>
            </table >
        </>
    );
});

export default TableExpanded